/**
 * Allocation buckets, as one-character codes.
 *
 * Two kinds, and the label was written out on every slice: "Sector Allocation"
 * 336 times, "Geographic Allocation" 95.
 *
 * The code also says how to read the slice's name. A geographic slice names a
 * place and is stored as a place code; a sector slice names a sector and is
 * stored as text, because there are ninety-odd of them and no standard set to
 * key them against.
 */
export type AllocationKind = 's' | 'g';

export interface AllocationMeta {
    label: string;
    /** Whether slice names are place codes rather than free text. */
    places: boolean;
}

export const ALLOCATION_KINDS: Record<string, AllocationMeta> = {
    s: { label: 'Sector Allocation', places: false },
    g: { label: 'Geographic Allocation', places: true },
};

export const allocationKindOf = (code: string): AllocationMeta =>
    ALLOCATION_KINDS[code] ?? { label: code, places: false };

const BY_LABEL: Record<string, string> = Object.fromEntries(
    Object.entries(ALLOCATION_KINDS).map(([code, meta]) => [meta.label.toLowerCase(), code]),
);

export const codeForAllocationKind = (label: string): string | null => BY_LABEL[label.trim().toLowerCase()] ?? null;
